// actions/media-library.actions.ts
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { MediaLibraryCategoryEnum, MediaLibraryFileModel, MediaLibraryTypeModel, MediaLibraryUploadType } from '../../../../models/sales-funnel';

export const MediaLibraryActions = createActionGroup({
  source: 'Load Media Library',
  events: {
    load: props<{ category: MediaLibraryCategoryEnum, uploadType: MediaLibraryUploadType | string }>(),
    loadSuccess: props<{ files: MediaLibraryFileModel[] }>(),
    loadFailure: props<{ error: any }>(),
  },
});

// Media Library Types
export const MediaLibraryTypesActions = createActionGroup({
  source: 'Load Media Library Types',
  events: {
    load: props<{ uploadType: MediaLibraryUploadType | string }>(),
    loadSuccess: props<{ types: MediaLibraryTypeModel[] }>(),
    loadFailure: props<{ error: any }>(),
  },
});

export const MediaLibraryQuotaActions = createActionGroup({
  source: 'Load Media Library Quota',
  events: {
    load: emptyProps(),
    loadSuccess: props<{ quota: any }>(),
    loadFailure: props<{ error: any }>(),
  },
});

export const MediaLibraryFileActions = createActionGroup({
  source: 'Delete Media Library File',
  events: {
    delete: props<{ file: MediaLibraryFileModel, force?: boolean }>(),
    deleteSuccess: props<{ fileId: number }>(),
    deleteFailure: props<{ fileId: number, error: any }>(),
  },
});

export const updateMediaLibraryFile = createAction('[File] File Updated Successfully', props<{ file: MediaLibraryFileModel }>());
export const addNewMediaLibraryFiles = createAction('[File] File Added Successfully', props<{ files: MediaLibraryFileModel[] }>());



